import { render, staticRenderFns } from "./siOrdersList.vue?vue&type=template&id=52dc84ec&"
import script from "./siOrdersList.vue?vue&type=script&lang=js&"
export * from "./siOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./siOrdersList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "siOrdersList.vue"
export default component.exports